import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import {
  TransactionSuccessQuery,
  TransactionSuccessService,
  LottoDetails,
  DATE_OPTIONS,
  CustomFieldValidationType,
  MarketplaceBasketCustomFieldModel,
} from '@fgb/core';

@Component({
  selector: 'fgb-lottos-success-page',
  templateUrl: './lottos-success-page.component.html',
  styleUrls: ['./lottos-success-page.component.scss'],
})
export class LottosSuccessPageComponent implements OnInit, OnDestroy {
  public lottoItem: LottoDetails;
  public customFields: MarketplaceBasketCustomFieldModel[] = [];
  public totalPrice: number;
  public quantity: number;

  private readonly transactionSuccessQuery = inject(TransactionSuccessQuery);
  private readonly transactionSuccessService = inject(TransactionSuccessService);
  readonly dateOptions = inject(DATE_OPTIONS);
  readonly customValidationType = CustomFieldValidationType;

  ngOnInit() {
    const transaction = this.transactionSuccessQuery.getValue();
    this.lottoItem = transaction.item as LottoDetails;
    this.customFields = transaction.customFields || [];
    this.totalPrice = transaction.totalPrice;
    this.quantity = transaction.quantity;
  }

  ngOnDestroy(): void {
    this.transactionSuccessService.clear();
  }
}
